import { useEffect } from "react";
import { notifications } from "@mantine/notifications";

export const useErrorToast = (
  message: string | null,
  title: string,
  onConsumed?: () => void,
): void => {
  useEffect(() => {
    if (!message) return;
    notifications.show({
      color: "red",
      title,
      message,
      withCloseButton: true,
    });
    onConsumed?.();
  }, [message, title, onConsumed]);
};
